 
 
import InputLabel from "@material-ui/core/InputLabel";
import OutlinedInput from "@material-ui/core/OutlinedInput";
import FormControl from "@material-ui/core/FormControl";

const index = ({additionClass,loading,label,htmlFor,tName,type,endAdornment,handleChange}) => {
    return (
        <FormControl className={"input BODY_EXTRA_LARGE "+additionClass} variant="outlined">
                <InputLabel htmlFor={htmlFor}>{label}</InputLabel>
                <OutlinedInput
                    type={type}
                    label={label}
                    id={htmlFor}
                    className="BODY_EXTRA_LARGE"
                    name={tName}
                    onChange={handleChange}
                    endAdornment={endAdornment}
                   
                />
         </FormControl>
    );
  }
  
  export default index;
  